import {useShopperBasketsMutation} from '@salesforce/commerce-sdk-react'
import {buildPriceTestParam} from '@/helpers/sfccHelpers'

interface Product {
    productId: string
    quantity: number
}

export const useAddItemToBasket = () => {
    const addItemToBasket = useShopperBasketsMutation('addItemToBasket')

    const handleAddItemToBasket = async (productItem: Product, basketId: string): Promise<void> => {
        if (!productItem) {
            throw new Error('No product item provided to add to basket.')
        }
        if (!basketId) {
            throw new Error('No basketId provided to add item to basket.')
        }
        try {
            await addItemToBasket.mutateAsync({
                parameters: {
                    basketId: basketId,
                    ...buildPriceTestParam()
                },
                body: [
                    {
                        productId: productItem.productId,
                        quantity: productItem.quantity
                    }
                ]
            })
            console.log('Item added to basket successfully')
        } catch (error) {
            console.error('Error adding item to basket:', error)
            throw error
        }
    }

    return {handleAddItemToBasket}
}
